import './styles/app.css';
import { mount } from 'svelte';
import "flyonui/flyonui";

const modules = import.meta.webpackContext('./svelte', {
    recursive: true,
    regExp: /\.svelte$/,
});

const components = {};
modules.keys().forEach((key) => {
    const filename = key.split('/').pop().replace('.svelte', '');
    components[filename] = modules(key).default;
});

// Mount Svelte components found in the DOM
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-svelte-component]').forEach((el) => {
        const componentName = el.dataset.svelteComponent;
        const Component = components[componentName];

        if (Component) {
            const props = el.dataset.svelteProps
                ? JSON.parse(el.dataset.svelteProps)
                : {};

            mount(Component, { target: el, props });
        } else {
            console.warn(`Svelte component "${componentName}" not found.`);
        }
    });
});
